import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getPackageList } from "../../api/api";
import "./OurPackagesPageCss/PackageDetailsPage.css";
import rbdLogo from "../../Assets/rbdLogo.png";
import { IoArrowBack } from "react-icons/io5";
import { useCart } from "../../Contexts/Cart.contexts";


function PackageDetailsSkeleton() {
    return (
        <div className="package-details-skeleton">

            {/* TOP CARD SKELETON */}
            <div className="skeleton-card">

                <div className="skeleton-back-btn"></div>

                <div className="skeleton-logo"></div>

                <div className="skeleton-title"></div>

                <div className="skeleton-line short"></div>
                <div className="skeleton-line"></div>
                <div className="skeleton-line"></div>

                <div className="skeleton-btn-row">
                    <div className="skeleton-btn"></div>
                    <div className="skeleton-btn"></div>
                </div>
            </div>

            <div className="skeleton-card skeleton0-lowercard">
                <div className="skeleton-param-title"></div>

                {[1, 2, 3, 4, 5, 6].map((i) => (
                    <div key={i} className="skeleton-accordion"></div>
                ))}
            </div>

        </div>
    );
}

function PackageDetailsPage() {
    const { id } = useParams();
    const navigate = useNavigate();

    const [packageData, setPackageData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    // Dropdown
    const [openIndex, setOpenIndex] = useState(null);

    // Buttons State
    const [copied, setCopied] = useState(false);
    const { addToCart, cartItems, setCartItems } = useCart();

    const toggleDropdown = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    // Extract test parameters
    const extractParameters = (list) => {
        if (!list) return [];
        return Array.isArray(list) ? list : Object.values(list);
    };

    const getParamName = (item) => {
        if (typeof item === "string") return item;
        return (
            item?.test_name ||
            item?.service_name ||
            item?.name ||
            item?.title ||
            "Untitled Test"
        );
    };

    const getParamDetails = (item) => {
        if (typeof item === "string") return null;

        return {
            Department: item.Department || "N/A",
            ReportTime: item.ReportTimeInDays
                ? `${item.ReportTimeInDays} day(s)`
                : "N/A",
            Preparation: item.service_preperation || "N/A",
            ServiceKey: item.service_key || "N/A",
        };
    };

    const fetchPackageDetails = async () => {
        try {
            setLoading(true);
            const res = await getPackageList({ search_key: "" });
            const data = res?.data?.data || [];

            const filtered = data.filter((item) => item.ShowInWeb === "Y");
            const pkg = filtered.find((p) => p.service_id == id);

            if (!pkg) setError(true);
            else setPackageData(pkg);
        } catch (err) {
            console.error("Fetch error:", err);
            setError(true);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPackageDetails();
    }, [id]);

    // useEffect(() => {
    //     const saved = JSON.parse(localStorage.getItem("cartItems") || "[]");
    //     setCartItems(saved);
    // }, []);

    const parameters = extractParameters(packageData?.list);

    // CHECK IF ADDED
    const isAdded = cartItems.some(
        (item) => item.id === packageData?.service_id || item.service_id === packageData?.service_id
    );


    // ADD TO CART USING CONTEXT
    const handleAddToCart = () => {
        if (isAdded) return;

        addToCart({
            id: packageData.service_id,
            product: packageData.service_name,
            price: packageData.price,
            quantity: 1,
        });
    };


    const handleCopyLink = () => {
        navigator.clipboard.writeText(window.location.href);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    const handleBookNow = () => {
        navigate(`/book/${packageData.service_id}`);
    };




    if (loading) {
        return <PackageDetailsSkeleton />
    }

    if (error || !packageData) {
        return (
            <div className="error-box">
                <h2>Package Not Found</h2>
                <button
                    onClick={() => navigate("/OurPackagesPage")}
                    className="back-btn"
                >
                    Go Back
                </button>
            </div>
        );
    }

    return (
        <div className="package-details-page">

            <div className="test-details-card health-package-details">

                {/* BACK BUTTON */}
                <div className="backButton" onClick={() => navigate("/OurPackagesPage")}>
                    <IoArrowBack size={22} /> Back
                </div>

                <div className="rbImage">
                    <img src={rbdLogo} alt="RB logo" />
                </div>

                {/* MAIN DETAILS */}
                <div className="fulltestDetailssec">
                    <div className="testHeadings">
                        <h1>{packageData.service_name}</h1>

                        <p><strong>Total Tests:</strong> {parameters.length}</p>
                        <p><strong>Components:</strong> {packageData.NoOfParams}</p>
                        <p><strong>Price:</strong> ₹{packageData.price}</p>
                    </div>
                </div>

                {/* BUTTONS */}
                <div className="button-row brhp">
                    <button
                        className={`book-btn ${isAdded ? "added" : ""}`}
                        onClick={handleAddToCart}
                    >
                        <span className="btn-text">
                            {isAdded ? "Added to Cart" : "Add to Cart"}
                        </span>
                    </button>

                    <button className="copy-btn" onClick={handleCopyLink}>
                        <span className="btn-text">
                            {copied ? "Link Copied!" : "Copy Link"}
                        </span>
                    </button>
                </div>
            </div>

            {/* LOWER SECTION */}
            <div className="packgaeDetailsPageLowerS">
                <h3>Parameters</h3>

                {parameters.map((item, i) => {
                    const name = getParamName(item);
                    const details = getParamDetails(item);

                    return (
                        <div key={i} className="accordion-item">

                            <div className="accordion-header" onClick={() => toggleDropdown(i)}>
                                <span>{name}</span>
                                <span>{openIndex === i ? "▲" : "▼"}</span>
                            </div>

                            {openIndex === i && details && (
                                <div className="accordion-content">
                                    <p><strong>Department:</strong> {details.Department}</p>
                                    <p><strong>Report Time:</strong> {details.ReportTime}</p>
                                    <p><strong>Preparation:</strong> {details.Preparation}</p>
                                    <p><strong>Service Key:</strong> {details.ServiceKey}</p>
                                </div>
                            )}

                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default PackageDetailsPage;
